var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "chat-message mb-2",
      attrs: { "data-test": "chat-message" },
      on: {
        mouseenter: function($event) {
          _vm.hovered = true
        },
        mouseleave: _vm.onMouseLeave
      }
    },
    [
      _c("div", { staticClass: "d-flex", class: _vm.alignClasses }, [
        _vm.isSystem
          ? _c(
              "div",
              {
                staticClass: "d-flex flex-column align-center",
                attrs: { "data-test": "message-system" }
              },
              [
                _c("ChatBadge", {
                  attrs: {
                    variant: "system",
                    text: _vm.mensagem.conteudo,
                    icon: _vm.isTransfer ? _vm.icons.transfer : _vm.icons.info
                  }
                }),
                _c(
                  "span",
                  { staticClass: "az-text-small az-muted message-time mt-1" },
                  [_vm._v(_vm._s(_vm.formattedTime))]
                )
              ],
              1
            )
          : _c(
              "div",
              {
                staticClass: "message-bubble pa-2 rounded",
                class: _vm.bubbleClasses,
                staticStyle: { position: "relative" },
                attrs: {
                  "data-test": _vm.isNote
                    ? "message-note"
                    : _vm.isIncoming
                    ? "message-incoming"
                    : "message-outgoing"
                }
              },
              [
                _vm.isNote
                  ? _c(
                      "div",
                      {
                        staticClass: "mb-1",
                        attrs: { "data-test": "note-header" }
                      },
                      [
                        _c("ChatBadge", {
                          attrs: {
                            variant: "note",
                            text: "Nota interna",
                            icon: _vm.icons.lock
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.isNote && _vm.noteProfessionalName
                  ? _c(
                      "div",
                      {
                        staticClass: "az-text-small font-medium mb-1",
                        style: { color: _vm.noteProfessionalColor },
                        attrs: { "data-test": "note-professional" }
                      },
                      [_vm._v(" " + _vm._s(_vm.noteProfessionalName) + " ")]
                    )
                  : _vm._e(),
                !_vm.isNote && _vm.senderName
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "az-text-small font-medium mb-1 sender-name",
                        attrs: { "data-test": "sender-name" }
                      },
                      [_vm._v(" " + _vm._s(_vm.senderName) + " ")]
                    )
                  : _vm._e(),
                _vm.hasReplyTo
                  ? _c("ChatReplyPreview", {
                      staticClass: "mb-1",
                      attrs: {
                        "sender-name": _vm.replyToSender,
                        content: _vm.replyToContent,
                        compact: ""
                      },
                      on: { "scroll-to": _vm.onReplyPreviewClick }
                    })
                  : _vm._e(),
                _vm.hasMedia
                  ? _c("ChatMediaPreview", {
                      staticClass: "mb-1",
                      attrs: {
                        api: _vm.api,
                        "media-url": _vm.resolvedMediaUrl,
                        "media-mime-type": _vm.mensagem.media_mime_type,
                        "media-filename": _vm.mensagem.media_filename,
                        "message-tipo": _vm.mensagem.tipo
                      }
                    })
                  : _vm._e(),
                _vm.editingInline
                  ? _c("div", { staticClass: "inline-edit-wrapper" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.editText,
                            expression: "editText"
                          }
                        ],
                        ref: "inlineEdit",
                        staticClass: "inline-edit-textarea",
                        attrs: { rows: "3", disabled: _vm.savingEdit },
                        domProps: { value: _vm.editText },
                        on: {
                          keydown: _vm.onEditKeydown,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.editText = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "d-flex justify-end mt-1",
                          staticStyle: { gap: "6px" }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "inline-edit-btn",
                              attrs: {
                                type: "button",
                                disabled: _vm.savingEdit
                              },
                              on: { click: _vm.cancelInlineEdit }
                            },
                            [_vm._v("Cancelar")]
                          ),
                          _c(
                            "button",
                            {
                              staticClass:
                                "inline-edit-btn inline-edit-btn--primary",
                              attrs: {
                                type: "button",
                                disabled: _vm.savingEdit || !_vm.editText.trim()
                              },
                              on: { click: _vm.saveInlineEdit }
                            },
                            [
                              _vm.savingEdit
                                ? _c("v-progress-circular", {
                                    staticClass: "mr-1",
                                    attrs: {
                                      indeterminate: "",
                                      size: "12",
                                      width: "2",
                                      color: "white"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" Salvar ")
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  : _vm.mensagem.conteudo
                  ? _c("div", {
                      staticClass: "az-text-primary az-size-14 message-text",
                      domProps: { innerHTML: _vm._s(_vm.formattedContent) }
                    })
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "d-flex align-center justify-end mt-1" },
                  [
                    _vm.hasLinkedTask
                      ? _c(
                          "span",
                          {
                            staticClass: "task-badge mr-1",
                            attrs: {
                              "data-test": "message-task-badge",
                              title: _vm.taskFromMessage.BADGE_TOOLTIP
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.onOpenTask(_vm.linkedTaskId)
                              }
                            }
                          },
                          [
                            _c("ChatBadge", {
                              attrs: {
                                variant: "date",
                                text: _vm.taskFromMessage.BADGE_LABEL,
                                icon: _vm.taskFromMessage.BADGE_ICON
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.canalBadge
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "canal-indicator d-inline-flex align-center mr-1",
                            attrs: {
                              "data-test": "canal-badge",
                              title: _vm.canalBadge.text
                            }
                          },
                          [
                            _c("icon-svg", {
                              staticClass: "mr-1",
                              attrs: {
                                name: _vm.canalBadge.icon,
                                size: "12",
                                color: _vm.canalBadge.color
                              }
                            }),
                            _c(
                              "span",
                              { staticClass: "az-text-small az-muted" },
                              [_vm._v(_vm._s(_vm.canalBadge.text))]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.isEdited
                      ? _c(
                          "span",
                          {
                            staticClass: "az-text-small az-muted mr-1",
                            staticStyle: {
                              "font-size": "10px",
                              "font-style": "italic"
                            },
                            attrs: { "data-test": "edited-indicator" }
                          },
                          [_vm._v(" editada ")]
                        )
                      : _vm._e(),
                    _c(
                      "span",
                      { staticClass: "az-text-small az-muted message-time" },
                      [_vm._v(" " + _vm._s(_vm.formattedTime) + " ")]
                    ),
                    _vm.isOutgoing && !_vm.isNote
                      ? [
                          _vm.mensagem.status === "enviando"
                            ? _c(
                                "span",
                                {
                                  staticClass: "status-icon ml-1",
                                  attrs: { "data-test": "status-enviando" }
                                },
                                [
                                  _c("icon-svg", {
                                    attrs: {
                                      name: _vm.icons.statusSending,
                                      size: "12",
                                      color: "grey"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm.mensagem.status === "enviada"
                            ? _c(
                                "span",
                                {
                                  staticClass: "status-icon ml-1",
                                  attrs: { "data-test": "status-enviada" }
                                },
                                [
                                  _c("icon-svg", {
                                    attrs: {
                                      name: _vm.icons.statusSent,
                                      size: "12",
                                      color: "grey"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm.mensagem.status === "entregue"
                            ? _c(
                                "span",
                                {
                                  staticClass: "status-icon ml-1",
                                  attrs: { "data-test": "status-entregue" }
                                },
                                [
                                  _c("icon-svg", {
                                    attrs: {
                                      name: _vm.icons.statusDelivered,
                                      size: "12",
                                      color: "grey"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm.mensagem.status === "lida"
                            ? _c(
                                "span",
                                {
                                  staticClass: "status-icon ml-1",
                                  attrs: { "data-test": "status-lida" }
                                },
                                [
                                  _c("icon-svg", {
                                    attrs: {
                                      name: _vm.icons.statusDelivered,
                                      size: "12",
                                      color: "blue"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm.isWhatsappRelayFailed
                  ? _c(
                      "div",
                      {
                        staticClass: "d-flex align-center mt-1",
                        attrs: { "data-test": "message-whatsapp-relay-failed" }
                      },
                      [
                        _c("icon-svg", {
                          staticClass: "mr-1",
                          attrs: {
                            name: _vm.icons.whatsapp,
                            size: "12",
                            color: "grey"
                          }
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "az-text-small az-muted",
                            staticStyle: { "font-size": "11px" }
                          },
                          [
                            _vm._v(
                              " Enviada no chat — não entregue por WhatsApp "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm.mensagem.status === "erro" && _vm.isOutgoing
                  ? _c(
                      "div",
                      {
                        staticClass: "d-flex align-center mt-1",
                        attrs: { "data-test": "message-error-banner" }
                      },
                      [
                        _c("icon-svg", {
                          staticClass: "mr-1",
                          attrs: {
                            name: _vm.icons.statusError,
                            size: "12",
                            color: "red"
                          }
                        }),
                        _c("span", { staticClass: "error-text red--text" }, [
                          _vm._v("Falha ao enviar.")
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "error-text ml-1 retry-link",
                            attrs: { "data-test": "retry-button" },
                            on: {
                              click: function($event) {
                                return _vm.$emit("retry", _vm.mensagem)
                              }
                            }
                          },
                          [_vm._v(" Toque para tentar novamente ")]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.hovered
                  ? _c("ChatMessageActions", {
                      attrs: {
                        mensagem: _vm.mensagem,
                        "bubble-color": _vm.bubbleColor,
                        "hide-note": _vm.hideNote,
                        "hide-task": _vm.hideTask,
                        "has-linked-client": _vm.hasLinkedClient,
                        "id-cliente-app": _vm.idClienteApp
                      },
                      on: {
                        reply: _vm.onReply,
                        edit: _vm.onEdit,
                        react: _vm.onReact,
                        "picker-toggle": _vm.onPickerToggle,
                        note: _vm.onNote,
                        delete: _vm.onDelete,
                        "create-task": _vm.onCreateTask,
                        "send-to-drive": _vm.onSendToDrive,
                        "send-to-drive-rename": _vm.onSendToDriveRename
                      }
                    })
                  : _vm._e()
              ],
              1
            )
      ]),
      _vm.hasReactions
        ? _c(
            "div",
            {
              staticClass: "d-flex mb-1",
              class: _vm.isOutgoing ? "justify-end pr-2" : "justify-start pl-2"
            },
            [
              _c(
                "div",
                { staticClass: "reactions-row d-flex" },
                _vm._l(_vm.reactionSummary, function(r, idx) {
                  return _c(
                    "span",
                    {
                      key: idx,
                      staticClass: "reaction-chip",
                      attrs: { title: r.names.join(", ") }
                    },
                    [
                      _vm._v(" " + _vm._s(r.emoji) + " "),
                      r.count > 1
                        ? _c("span", { staticClass: "reaction-count" }, [
                            _vm._v(_vm._s(r.count))
                          ])
                        : _vm._e()
                    ]
                  )
                }),
                0
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }